import { SourceSystemNames } from "../config/sourceSystemNames";
import {
  CNPSourceSystem,
  ValueMyCarSourceSystem,
  QuotationsSourceSystem,
  SellMyCarSourceSystem,
  BranchAppraisalSourceSystem,
  BranchJourneySourceSystem
} from "./SourceSystems";
import { SourceSystem } from "./SourceSystems/BaseSourceSystem";

export class SourceSystemFactory {
  getSourceSystem(
    name: keyof typeof SourceSystemNames,
    redirectUri: string,
    navigate: INavigate,
    exitUri: string
  ): SourceSystem {
    switch (name) {
      case SourceSystemNames.ValueMyCar:
      case SourceSystemNames.SalesOfficeCustomer:
        return new ValueMyCarSourceSystem(redirectUri, exitUri, navigate);
      case SourceSystemNames.SalesOffice:
      case SourceSystemNames.ValuationAdmin:
        return new BranchJourneySourceSystem(redirectUri, exitUri, navigate);
      case SourceSystemNames.BranchAppraisal:
        return new BranchAppraisalSourceSystem(redirectUri, exitUri, navigate);
      case SourceSystemNames.SellMyCar:
        return new SellMyCarSourceSystem(redirectUri, exitUri, navigate);
      case SourceSystemNames.SalesCNP:
        return new CNPSourceSystem(redirectUri, exitUri, navigate);
      case SourceSystemNames.Quotations:
        return new QuotationsSourceSystem(redirectUri, exitUri, navigate);
      default:
        return new ValueMyCarSourceSystem(redirectUri, exitUri, navigate);
    }
  }
}
